import React, { useEffect } from 'react';
import { MeatballMenu, getValidationStyle, Validation, ValidationLevel } from 'ui';
import { AccessCardProps } from './types';
import { AccessSwitch } from './access-switch';
import { AccessLabel } from './access-label';
import { getUniqueMessages } from './data';

import styles from './access-card.scss';

export const AccessCard: React.FC<AccessCardProps> = (props) => {

  const { componentId, readOnly, label, readOnlyLabel, removeLabel,
    useLabelOption = false, fetching, options, invalidOptions,
    valueItems, initialValueItems,
    onChange, onDelete, onLoadOptions,
    validation: { messages = [] } = {},
    children
  } = props;

  useEffect(
    () => {
      if ((!useLabelOption || !options) && onLoadOptions) {
        onLoadOptions(undefined);
      }
    },
    [componentId]
  );

  if (fetching || ((useLabelOption || !valueItems) && !options)) {
    return <div id={componentId} />;
  }

  const level = messages && messages[0] && messages[0].level;
  const errorStyle = getValidationStyle(level) === 'danger' ? styles.hasDanger : '';
  const readOnlyStyle = readOnly ? styles.readOnly : '';

  const groupClassname = `col-lg-6 ${level !== undefined || 'valid'}`;
  const shouldRenderHeader = !!label || !!messages.length || (!readOnly && !!onDelete);

  return <div className={groupClassname} id={componentId}>
    <div className={styles.accessCardContainer}>
      <div className={`${styles.accessCard} ${errorStyle} ${readOnlyStyle}`}>
        {shouldRenderHeader && <div className={styles.accessHeader}>
          <div>
            {!!label && <h3>{label.text}</h3>}
            {!!messages.length && <Validation level={ValidationLevel.error} messages={getUniqueMessages(messages)} />}
          </div>
          {!readOnly && !!onDelete && <MeatballMenu className={styles.meatball} closeAfterClick>
            <li>
              <button type="button" className="dropdown-item" onClick={onDelete}>
                {removeLabel}
              </button>
            </li>
          </MeatballMenu>}
        </div>}
        <ol className={styles.accessContent}>
          {useLabelOption
            ? <AccessLabel options={options} invalidOptions={invalidOptions} onChange={onChange} onDelete={onDelete} readOnly={readOnly} />
            : <AccessSwitch options={options} invalidOptions={invalidOptions}
              valueItems={valueItems} initialValueItems={initialValueItems}
              onChange={onChange} readOnly={readOnly} readOnlyLabel={readOnlyLabel} />}
        </ol>
        {children}
      </div>
    </div>
  </div>;
};
